module.exports = __webpack_public_path__ + "static/assets/e48e8bc4ca2913e19da20f085e9adbe9.svg";